export enum OrderProductionStatus {
    NotApplicable = -1,
    Pending = 0,
    Open = 1,
    InProduction = 2,
    Produced = 3
}

export const OrderProductionStatusMetadata = {
    '-1': {
        display: 'Not Applicable',
        class: 'na',
        value: -1
    },
    '0': {
        display: 'Pending',
        class: 'waiting',
        value: 0
    },
    '1': {
        display: 'Open',
        class: 'waiting',
        value: 1
    },
    '2': {
        display: 'In-Production',
        class: 'inprogress',
        value: 2
    },
    '3': {
        display: 'Produced',
        class: 'done',
        value: 3
    }
};
